import { IShipmentLocationRequest } from '@cemex-core/cmx-api';
import { createAction, props } from '@ngrx/store';
import { CxShipmentLocation } from '../../models/shipment-location';

export const resetState = createAction('[SHIPMENT_LOCATION] Reset State');
export const resetEntityState = createAction('[SHIPMENT_LOCATION] Reset Entity', props<{ id: string }>());
export const fetchEntity = createAction('[SHIPMENT_LOCATION] Fetch Entity start', props<IShipmentLocationRequest>());

export const updateEntity = createAction('[SHIPMENT_LOCATION] Update Entity', props<{ payload: CxShipmentLocation }>());
export const updateEntities = createAction(
  '[SHIPMENT_LOCATION] Update Entities',
  props<{ payload: CxShipmentLocation[] }>(),
);
export const selectEntity = createAction('[SHIPMENT_LOCATION] Select Entity', props<{ id: string }>());

export const CxShipmentLocationActions = {
  resetState,
  resetEntityState,

  updateEntity,
  updateEntities,
  selectEntity,

  fetchEntity,
};

export default CxShipmentLocationActions;
